import { Box, Flex, FloraButton, FloraButtonProps, Heading } from '@grupoboticario/flora-react'
import { slugify } from '@grupoboticario/tag-book-sellout'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSlidesToShow } from 'src/hooks'
import { useResellerContext } from 'src/hooks/useResellerContext'
import { trackShopWindowGAEvents } from 'src/service/trackShopWindowGAEvents'
import { CarouselShop } from './CarouselShop'
import { LoadingSkeleton } from './LoadingSkeleton'
import { ShopWindowItemProps, ShopWindowType } from './types'

export const ShopWindowItem = ({
  products,
  shopWindowType,
  shopWidth,
  isMobile,
  isLoading,
  seeMoreUrl,
  slidesToShow: slidesToShowFromProps,
}: ShopWindowItemProps) => {
  const slidesToShowDefault = useSlidesToShow()
  const reseller = useResellerContext()
  const navigate = useNavigate()
  const [shopWindowTitle, setShopWindowTitle] = useState<ShopWindowType>(
    ShopWindowType.PROMPT_DELIVERY,
  )
  const [navigationUrl, setNavigationUrl] = useState('')
  const handleNavigate = () => {
    trackShopWindowGAEvents({
      cd_interaction_detail: `click:ver-tudo:${slugify(shopWindowType)}`,
      cd_section: shopWindowType,
    })

    navigate(navigationUrl)
  }

  const seeMoreButtonProps: FloraButtonProps = {
    ...(seeMoreUrl ? { as: 'a', href: seeMoreUrl } : { type: 'button', onClick: handleNavigate }),
  }
  useEffect(() => {
    if (shopWindowType === ShopWindowType.PROMPT_DELIVERY) {
      setNavigationUrl(`/${reseller?.reseller?.catalogSlug}/pronta-entrega`)
      setShopWindowTitle(ShopWindowType.PROMPT_DELIVERY)
    }

    if (shopWindowType === ShopWindowType.ON_SALE) {
      setShopWindowTitle(ShopWindowType.ON_SALE)
      setNavigationUrl(`/${reseller?.reseller?.catalogSlug}/categoria?category=promocao`)
    }

    if (shopWindowType === ShopWindowType.BEST_SELLERS) {
      setShopWindowTitle(ShopWindowType.BEST_SELLERS)
    }

    if (shopWindowType === ShopWindowType.CAMPAIGN) {
      setShopWindowTitle(ShopWindowType.CAMPAIGN)
    }
  }, [reseller?.reseller?.catalogSlug, seeMoreUrl, shopWindowType])

  return (
    <Box css={{ margin: '$4 0' }}>
      <Flex
        align="center"
        justify="space-between"
        css={{ marginBottom: '$3' }}
      >
        <Heading
          level="6"
          color="$nonInteractivePredominant"
          id="carousel-heading"
        >
          {shopWindowTitle}
        </Heading>
        {seeMoreUrl || navigationUrl ? (
          <FloraButton
            hierarchy="secondary"
            size="small"
            {...seeMoreButtonProps}
          >
            Ver tudo
          </FloraButton>
        ) : null}
      </Flex>
      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <Box
          css={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <CarouselShop
            isMobile={isMobile}
            shopWindowType={shopWindowType}
            products={products ?? []}
            shopWidth={shopWidth}
            slidesToShow={slidesToShowFromProps || slidesToShowDefault}
          />
        </Box>
      )}
    </Box>
  )
}
